<template>
  <div>

    <q-dialog v-model="subBatchDialog" scrollable persistent position="right">
      <q-card style="min-width: 800px">
        <q-card-section>
          <div class="text-h6">Manage Active Sub-batches
            <q-btn class="float-right" @click="closeDialog" flat round icon="close" size="small"></q-btn>
            <q-input class="searchBox filterBox" debounce="800" placeholder="Search by batch"
                     v-model="filter" @input="onSearch">
              <template v-slot:prepend><q-icon name="search"/></template>
            </q-input>
          </div>
        </q-card-section>
        <!--      <q-linear-progress v-if="fetchActiveSubBatchLoading" indeterminate/>-->
        <q-separator/>

        <q-card-section class="scroll p-4" style="max-height: 70vh">
          <div class="row justify-center q-my-md" v-if="initialLoading || $apollo.queries.batchesCount.loading">
            <q-spinner-dots color="primary" size="40px" />
          </div>
          <q-infinite-scroll @load="onLoad" :offset="250" v-else>
            <div class="row q-col-gutter-sm">
              <template v-for="(b, index) in batches">
                <div class="col-12" :key="b.id">
                  <div class="mb-4">
                    <span class="text-h6">{{b.batch}}</span>
                    <q-btn class="float-right mt-2 ml-4" color="grey" @click="addRetailSales(b)"
                           :loading="b.loading">Retail Sales</q-btn>
                    <q-btn class="float-right mt-2" color="primary" @click="transferBatch(b)"
                           v-if="![Constant.VAP, Constant.RP].includes(user.organization.partnerType)">
                      Transfer</q-btn>
                    <div class="text-grey-6">Product: {{ b.Product&&b.Product.name }}</div>
                  </div>
                  <div class="text-grey-8 mb-2">Sub-batches</div>
                  <q-list dense>
                    <q-item v-for="sb in b.subBatches" :key="sb.id">
                      <li> {{sb.serial}}</li>
                    </q-item>
                  </q-list>
                  <hr v-if="index+1<batches.length" class="mb-2">
                </div>
              </template>
            </div>
            <template v-slot:loading>
              <div class="row justify-center q-my-md">
                <q-spinner-dots color="primary" size="40px" />
              </div>
            </template>
          </q-infinite-scroll>
          <div v-if="!initialLoading && !$apollo.queries.batchesCount.loading && !totalBatchcount">
            No Active Sub-batch available.
          </div>
        </q-card-section>

      </q-card>
    </q-dialog>

    <TransferBatch ref="transfer-batch-comp" :form-dialog.sync="transferBatchDialog"/>
  </div>
</template>

<script>
import TransferBatch from "@/components/ManageSubBatches/TransferBatch";
import retailSalesEntry from "@/mixins/retailSalesEntry";
import Vue from 'vue';
import Constant from "@/Constants/Constant";
import {
  GET_ACTIVE_SUB_BATCH_TOTAL_COUNT,
  GET_ACTIVE_SUB_BATCH_WITH_LIMIT
} from "@/graphql/queries/batch";

export default {
  name: "ManageActiveSubBatches",
  components: {TransferBatch},
  props: ['subBatchDialog'],
  mixins: [retailSalesEntry],
  apollo: {
    batchesCount: {
      query: GET_ACTIVE_SUB_BATCH_TOTAL_COUNT,
      fetchPolicy: 'network-only',
      skip() {return !this.subBatchDialog},
      variables () { return { orgId: this.user.orgId, filter: `%${this.filter}%` }},
      result({data}) { this.totalBatchcount = data.batchesCount.aggregate.count;
        /* console.log('fetched totalCount') */ }
    },
  },
  data() {
    return {
      user: JSON.parse(localStorage.user),
      Constant,
      batches: [],
      transferBatchDialog: false,
      offset: 0,
      limit: 5,
      totalBatchcount: 0,
      initialLoading: true,
      filter: ''
    }
  },
  methods: {
    async onSearch () {
      this.batches = []
      this.initialLoading = true
      this.offset = 0                     //Reset offset when Search
      await this.fetchBatches()
      this.initialLoading = false
    },
    async onLoad (index, done) {
      // console.log('onLoad called - Index', index)
      if (this.batches.length === this.totalBatchcount) {
        done(true)
      } else {
        // console.log('fetch more batches called')
        this.offset = this.offset + this.limit
        await this.fetchBatches()
        done()
      }
    },
    async fetchBatches(){
      let response = await this.$apollo.query({
        query: GET_ACTIVE_SUB_BATCH_WITH_LIMIT,
        fetchPolicy: 'network-only',
        variables: {
          orgId: this.user.orgId, offset: this.offset, limit: this.limit, filter: `%${this.filter}%`
        }
      })
      if(response.data) {
        this.batches = [...this.batches, ...response.data.batches]
      }
      // console.log('Batches fetched')
    },
    transferBatch(batchObj){
      this.$refs['transfer-batch-comp'].setBatches([batchObj]);
      this.transferBatchDialog = true;
    },
    async addRetailSales(batch){
      Vue.set(batch, 'loading', true);
      let from = {orgId:this.user.orgId, userId:this.user.id};
      for(const sb of batch.subBatches){
        await this.addEntry(sb.serial, from);
      }
      Vue.set(batch, 'loading', false);
      this.$q.notify(`Retail Sales Entry added Successfully for batch ${batch.batch}`)
    },
    /* async addRetailSales(subBatchObj){
       Vue.set(subBatchObj, 'loading', true);
       let from = {orgId:this.user.orgId, userId:this.user.id};
       await this.addEntry(subBatchObj.serial, from);
       Vue.set(subBatchObj, 'loading', false);
     }, */
    closeDialog(){
      this.$emit('update:subBatchDialog', false)
    }
  },
  async created(){
    await this.fetchBatches()
    this.initialLoading = false
  }
}
</script>

<style scoped>
.fullscreen-card{
  min-width: calc(100vw - 80px) !important;
  /*min-height: 95vh;*/
}
.filterBox{
  width: 300px;
  display: inline-block;
  float: right;
  margin-top: -8px;
  margin-right: 50px;
  padding-top: 0;
}
</style>
